"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
const defaults_1 = require("./defaults");
const image_object_1 = __importDefault(require("./image-object"));
class Segment extends base_1.default {
    constructor(data = {
        id: undefined,
        title: undefined,
        friendly_name: undefined,
        icon: undefined,
        container: undefined,
        order: undefined,
    }) {
        super(data);
        this.title = (0, defaults_1.defaultString)(data.title);
        this.friendly_name = (0, defaults_1.defaultString)(data.friendly_name);
        this.icon = new image_object_1.default((0, defaults_1.defaultObject)(data.icon));
        this.container = (0, defaults_1.defaultString)(data.container);
        this.order = (0, defaults_1.defaultNumber)(data.order);
    }
}
exports.default = Segment;
